import React from "react";
import { IFormField } from "../../../../utils/form-utils";
import { FormField } from "../../../shared-ui/form/form-field/form-field";
import FormSection from "../../../shared-ui/form/form-section/form-section";
import TextInput from "../../../shared-ui/input/text-input/text-input";
import styles from "./pool-name-section.module.scss";


export interface IPoolNameSectionProps {
  name: IFormField<string>;
}

export function PoolNameSection(props: IPoolNameSectionProps) {
  return (   
    <FormSection testId="shard-cluster-name-section" title="Shard Cluster Name" className={styles.section}>
      <FormField label="Shard Cluster Name" error={props.name.error} testId="shard-cluster-name-field">
        <TextInput
          className={styles.name}
          testId="shard-cluster-name-input"
          field={props.name}
          placeholder="ex 'default shard cluster'"
          autoFocus={true}
        />
      </FormField>
    </FormSection>
  );
}
